import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  summaryWrapper: {
    display: 'flex',
    padding: '32px 40px',
    alignItems: 'center',
    position: 'relative',
    marginBottom: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap',
      flexDirection: 'column'
    },
    '& div:last-child': {
      paddingBottom: '0'
    }
  },
  summaryBlock: {
    flex: '1 1 0px',
    paddingRight: '40px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      paddingRight: '20px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%',
      paddingRight: '0',
      padding: '10px 0'
    },
    '& + &': {
      borderLeft: "2px solid ".concat(palette.shades[300]),
      paddingLeft: '40px',
      [breakpointsFunc.breakpoints.down('lg')]: {
        paddingLeft: '20px'
      },
      [breakpointsFunc.breakpoints.down('md')]: {
        borderLeft: "none",
        borderTop: "1px solid ".concat(palette.shades[300]),
        paddingLeft: '0'
      }
    }
  },
  monthTitle: {
    maxWidth: '160px',
    textAlign: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      maxWidth: 'initial',
      textAlign: 'initial',
      paddingBottom: '10px',
      paddingTop: '0'
    },
    '&:before': {
      content: '""',
      width: '16px',
      height: '16px',
      backgroundColor: palette.primary.main,
      display: 'inline-block',
      borderRadius: '2px',
      position: 'absolute',
      top: '-8px',
      left: '92px',
      boxShadow: palette.shadows.mid,
      [breakpointsFunc.breakpoints.down('md')]: {
        left: '40px'
      }
    }
  }
});
export default useStyles;